var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgStarFilled = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.425,
    height: 35.681,
    viewBox: "0 0 38.425 35.681",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ios-star",
    d: "M68.967,60.351H56.35L52.516,48.909a1.389,1.389,0,0,0-2.607,0L46.075,60.351h-12.7A1.376,1.376,0,0,0,32,61.723a1.008,1.008,0,0,0,.026.232,1.319,1.319,0,0,0,.575.969l10.37,7.308L38.99,81.8a1.376,1.376,0,0,0,.472,1.544,1.327,1.327,0,0,0,.772.335,1.682,1.682,0,0,0,.858-.309l10.121-7.213,10.121,7.213a1.607,1.607,0,0,0,.858.309,1.232,1.232,0,0,0,.763-.335,1.359,1.359,0,0,0,.472-1.544l-3.98-11.57L69.73,62.856l.249-.214a1.312,1.312,0,0,0-1.012-2.29Z",
    transform: "translate(-32 -48)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star-filled.876139d1.svg";
export { ForwardRef as ReactComponent };